import React, { createContext, useContext, useEffect, useState } from "react";

export const CONTACT = {
  email: "info@onallogistics.com",
  whatsapp: "https://wa.me/12014584272",
  location: "New Jersey, USA",
};

const tr = {
  nav: {
    process: "Nasıl Çalışır",
    services: "Hizmetler",
    stories: "Referanslar",
    quote: "Teklif",
    faq: "S.S.S.",
    contact: "İletişim",
    cta: "Teklif Al",
  },
  hero: {
    eyebrow: "NEW JERSEY, ABD — 3PL & FULFILLMENT MERKEZİ",
    lines: ["ÜRÜNÜNÜZ", "NEW JERSEY'DE,", "SATIŞINIZ AMAZON'DA."],
    sub: "ON-ALL LLC, Türkiye'den ve diğer ülkelerden gönderdiğiniz ürünleri New Jersey'deki depomuzda karşılar. İsteğinize göre ürünleriniz alıcısına teslim edilir ya da Amazon'da satışa çıkarılır — tüm operasyon tarafımızca yürütülür.",
    ctaPrimary: "Teklif Al",
    ctaSecondary: "Nasıl Çalışır?",
    badge: "DEPO KABUL AÇIK",
    stats: [
      { value: "1", label: "ABD Depo Adresi", meta: "NJ // USA" },
      { value: "5+", label: "Ürün Kategorisi", meta: "TEKSTİL — OYUNCAK" },
      { value: "2", label: "Operasyon Modeli", meta: "FBA & DIRECT" },
      { value: "0", label: "Gıda & Soğuk Zincir", meta: "KABUL EDİLMEZ" },
    ],
  },
  marquee: {
    items: ["TEKSTİL", "HEDİYELİK EŞYA", "AYAKKABI", "EV ÜRÜNLERİ", "OYUNCAK", "EL SANATLARI"],
    excluded: "GIDA & SOĞUK ZİNCİR HARİÇ",
  },
  process: {
    eyebrow: "SÜREÇ",
    title: "Üç adımda ABD operasyonunuz",
    steps: [
      {
        no: "01",
        title: "Depomuza Gönderin",
        text: "Türkiye'den veya başka bir ülkeden kargonuzu New Jersey'deki ON-ALL depo adresine yönlendirin.",
        tag: "INBOUND",
      },
      {
        no: "02",
        title: "Kabul & Hazırlık",
        text: "Ürünleriniz depomuzda kabul edilir, kontrol edilir ve satışa ya da teslime hazır hale getirilir.",
        tag: "PREP",
      },
      {
        no: "03",
        title: "Satışa veya Teslime",
        text: "İsteğinize göre ürünleriniz Amazon'da satışa çıkarılır ya da doğrudan alıcısına teslim edilir.",
        tag: "OUTBOUND",
      },
    ],
  },
  services: {
    eyebrow: "HİZMETLER",
    title: "Tek çatı altında ABD operasyonu",
    warehouse: {
      eyebrow: "01 — DEPO ADRESİ",
      title: "New Jersey'deki Depo Adresiniz",
      text: "Ürünleriniz için güvenilir kabul ve depolama noktası. Kargonuzu ABD adresimize yönlendirin, gerisini biz yapalım.",
      address: "ON-ALL LLC // NEW JERSEY, USA",
      status: "KABUL AÇIK",
    },
    fba: {
      title: "Amazon FBA Hazırlık & Satış",
      text: "Etiketleme, paketleme ve FBA gereklilikleri tamamlandıktan sonra ürünleriniz Amazon üzerinden satışa çıkarılır.",
    },
    direct: {
      title: "Alıcıya Doğrudan Teslim",
      text: "Müşterinizin siparişi, depomuzdan doğrudan alıcısına gönderilir.",
      route: "NJ → TÜM ABD",
    },
    ops: {
      eyebrow: "04 — OPERASYON",
      title: "Uçtan Uca Operasyon Yönetimi",
      text: "Kabul, stok, paketleme, sevkiyat ve takip: tüm süreç tek noktadan, bizim tarafımızdan yürütülür.",
      items: ["KABUL & KONTROL", "STOK TAKİBİ", "PAKETLEME", "SEVKİYAT", "SİPARİŞ TAKİBİ"],
    },
    market: {
      eyebrow: "05 — BÜYÜK PERAKENDE",
      title: "Büyük Marketlere Sunum",
      text: "Ürünleriniz büyük perakende zincirlerine tanıtılır ve sunulur; raflara giden yolda tüm operasyon tarafımızca yürütülür.",
      route: "B2B // MAJOR RETAIL",
    },
    categories: {
      label: "KABUL EDİLEN KATEGORİLER",
      note: "Gıda ürünleri ve soğuk zincir ürünleri kabul kapsamımızda değildir.",
      excluded: "GIDA & SOĞUK ZİNCİR HARİÇ",
    },
  },
  band: {
    line1: "Operasyon bizde.",
    line2: "Satış sizde.",
  },
  quote: {
    eyebrow: "TEKLİF",
    title: "Operasyonunuzu anlatın, size özel teklif hazırlayalım",
    note: "Fiyat listesi yok — her operasyon hacmine ve modele göre size özel planlanır.",
    serviceLabel: "Hizmet Modeli",
    serviceOptions: ["Amazon'da Satış (FBA Hazırlık)", "Alıcıya Doğrudan Teslim", "Büyük Marketlere Sunum", "Her İkisi"],
    categoryLabel: "Ürün Kategorisi",
    categories: ["Tekstil & Giyim", "Hediyelik Eşya", "Ayakkabı & Aksesuar", "Ev & Yaşam", "Oyuncak & Hobi", "El Sanatları", "Diğer"],
    volumeLabel: "Aylık Gönderi Adedi",
    summaryTitle: "OPERASYON PROFİLİNİZ",
    summaryEmpty: "Seçimlerinizi yapın, profiliniz burada oluşacak.",
    service: "HİZMET",
    category: "KATEGORİ",
    volume: "HACİM",
    unitsPerMonth: "adet / ay",
    formTitle: "İLETİŞİM BİLGİLERİ",
    name: "Ad Soyad *",
    company: "Firma (opsiyonel)",
    email: "E-posta *",
    phone: "Telefon (opsiyonel)",
    message: "Mesajınız",
    messagePlaceholder: "Ürünleriniz, hedefleriniz, sorularınız…",
    submit: "Teklif Talebi Gönder",
    sending: "Gönderiliyor…",
    success: "Talebiniz alındı! En kısa sürede size dönüş yapacağız.",
    error: "Bir sorun oluştu, lütfen tekrar deneyin.",
    invalidEmail: "Geçerli bir e-posta adresi girin.",
    required: "Lütfen zorunlu alanları doldurun.",
    volumeValue: (v) => `${v} adet / ay`,
  },
  stories: {
    eyebrow: "REFERANSLAR",
    title: "Birlikte büyüyen hikâyeler",
    items: [
      {
        quote: "Kargomuzu New Jersey adresine gönderdikten sonra tüm süreç bizim için görünmez şekilde yürütüldü. Amazon siparişleri aksamadan çıkmaya devam etti.",
        role: "Tekstil Satıcısı — Türkiye",
      },
      {
        quote: "Alıcıya doğrudan teslim sayesinde ABD'deki müşterilerimize, sanki orada yerel bir depomuz varmış gibi hizmet verebiliyoruz.",
        role: "Ev Ürünleri İhracatçısı — İzmir",
      },
      {
        quote: "Operasyon profilimizi ilettikten sonra her şey hızlıca planlandı; ilk sevkiyatımızı kısa sürede yaptık.",
        role: "Hediyelik Eşya Markası — İstanbul",
      },
    ],
  },
  faq: {
    eyebrow: "S.S.S.",
    title: "Sık sorulan sorular",
    items: [
      {
        q: "Hangi ürünleri kabul ediyorsunuz?",
        a: "Tekstil, hediyelik eşya, ayakkabı, ev ürünleri, oyuncak gibi soğuk zincir gerektirmeyen tüm genel ticaret ürünlerini kabul ediyoruz. Gıda ürünleri ve soğuk zincir ürünleri kabul kapsamımızda değildir.",
      },
      {
        q: "Ürünlerim Amazon'da nasıl satışa çıkar?",
        a: "Depomuzda kabul edilen ürünleriniz; hazırlık, etiketleme ve paketleme işlemleri tamamlanarak Amazon üzerinden satışa çıkarılır. Operasyonun tamamı ON-ALL tarafından yürütülür.",
      },
      {
        q: "Depo adresinizi nasıl kullanırım?",
        a: "Teklif formunu gönderdikten sonra size özel New Jersey depo adresimizi ve kabul talimatlarını iletiyoruz. Kargonuzu bu adrese yönlendirmeniz yeterli.",
      },
      {
        q: "Fiyatlandırma nasıl belirleniyor?",
        a: "Gönderi hacminize ve seçtiğiniz hizmet modeline göre size özel teklif hazırlıyoruz. Hesaplayıcıyı doldurun, talebiniz bize ulaştığında en kısa sürede dönüş yapalım.",
      },
    ],
  },
  footer: {
    tagline: "ABD'nin kalbinde, New Jersey'deki depomuzla fulfillment ve Amazon operasyon merkeziniz.",
    navTitle: "SİTE",
    contactTitle: "İLETİŞİM",
    rights: "Tüm hakları saklıdır.",
    excluded: "Gıda & soğuk zincir ürünleri kabul edilmez.",
  },
  whatsappFloat: "WhatsApp'tan Yazın",
};

const en = {
  nav: {
    process: "How It Works",
    services: "Services",
    stories: "Stories",
    quote: "Get a Quote",
    faq: "FAQ",
    contact: "Contact",
    cta: "Get a Quote",
  },
  hero: {
    eyebrow: "NEW JERSEY, USA — 3PL & FULFILLMENT HUB",
    lines: ["YOUR PRODUCTS", "IN NEW JERSEY,", "YOUR SALES ON AMAZON."],
    sub: "ON-ALL LLC receives your shipments from Türkiye and beyond at our New Jersey warehouse. On your request, we deliver to your buyers or list your products on Amazon — the entire operation is run by us.",
    ctaPrimary: "Get a Quote",
    ctaSecondary: "How It Works",
    badge: "WAREHOUSE ACCEPTING",
    stats: [
      { value: "1", label: "US Warehouse Address", meta: "NJ // USA" },
      { value: "5+", label: "Product Categories", meta: "APPAREL — TOYS" },
      { value: "2", label: "Operation Models", meta: "FBA & DIRECT" },
      { value: "0", label: "Food & Cold Chain", meta: "NOT ACCEPTED" },
    ],
  },
  marquee: {
    items: ["APPAREL", "GIFT ITEMS", "SHOES", "HOME GOODS", "TOYS", "HANDICRAFTS"],
    excluded: "NO FOOD & COLD CHAIN",
  },
  process: {
    eyebrow: "PROCESS",
    title: "Your US operation in three steps",
    steps: [
      {
        no: "01",
        title: "Ship to Our Warehouse",
        text: "Send your cargo from Türkiye or any other country to the ON-ALL warehouse address in New Jersey.",
        tag: "INBOUND",
      },
      {
        no: "02",
        title: "Receiving & Prep",
        text: "Your products are received, inspected and made ready for sale or delivery at our warehouse.",
        tag: "PREP",
      },
      {
        no: "03",
        title: "Sell or Deliver",
        text: "On your request, products are listed on Amazon or delivered directly to your buyers.",
        tag: "OUTBOUND",
      },
    ],
  },
  services: {
    eyebrow: "SERVICES",
    title: "Your entire US operation under one roof",
    warehouse: {
      eyebrow: "01 — WAREHOUSE ADDRESS",
      title: "Your New Jersey Warehouse Address",
      text: "A reliable receiving and storage point for your products. Route your cargo to our US address and leave the rest to us.",
      address: "ON-ALL LLC // NEW JERSEY, USA",
      status: "ACCEPTING",
    },
    fba: {
      title: "Amazon FBA Prep & Selling",
      text: "Once labeling, packaging and FBA requirements are complete, your products go live on Amazon.",
    },
    direct: {
      title: "Direct Delivery to Buyers",
      text: "Your customer's order ships from our warehouse straight to the buyer.",
      route: "NJ → ALL US",
    },
    ops: {
      eyebrow: "04 — OPERATIONS",
      title: "End-to-End Operations Management",
      text: "Receiving, inventory, packing, shipping and tracking — the entire process is managed from a single point, by us.",
      items: ["RECEIVING & QC", "INVENTORY", "PACKING", "SHIPPING", "ORDER TRACKING"],
    },
    market: {
      eyebrow: "05 — MAJOR RETAIL",
      title: "Major Retail Presentations",
      text: "Your products are presented to major retail chains — we run the entire operation on the way to the shelves.",
      route: "B2B // MAJOR RETAIL",
    },
    categories: {
      label: "ACCEPTED CATEGORIES",
      note: "Food and cold chain products are outside our acceptance scope.",
      excluded: "NO FOOD & COLD CHAIN",
    },
  },
  band: {
    line1: "We run operations.",
    line2: "You run sales.",
  },
  quote: {
    eyebrow: "QUOTE",
    title: "Tell us about your operation — we'll prepare a custom quote",
    note: "No price list — every operation is tailored to your volume and model.",
    serviceLabel: "Service Model",
    serviceOptions: ["Sell on Amazon (FBA Prep)", "Direct Delivery to Buyer", "Major Retail Presentations", "Both"],
    categoryLabel: "Product Category",
    categories: ["Apparel & Textiles", "Gift Items", "Shoes & Accessories", "Home & Living", "Toys & Hobbies", "Handicrafts", "Other"],
    volumeLabel: "Monthly Shipment Volume",
    summaryTitle: "YOUR OPERATION PROFILE",
    summaryEmpty: "Make your selections and your profile will appear here.",
    service: "SERVICE",
    category: "CATEGORY",
    volume: "VOLUME",
    unitsPerMonth: "units / month",
    formTitle: "CONTACT DETAILS",
    name: "Full Name *",
    company: "Company (optional)",
    email: "Email *",
    phone: "Phone (optional)",
    message: "Your Message",
    messagePlaceholder: "Your products, goals, questions…",
    submit: "Send Quote Request",
    sending: "Sending…",
    success: "Request received! We'll get back to you shortly.",
    error: "Something went wrong, please try again.",
    invalidEmail: "Please enter a valid email address.",
    required: "Please fill in the required fields.",
    volumeValue: (v) => `${v} units / month`,
  },
  stories: {
    eyebrow: "STORIES",
    title: "Stories that grow with us",
    items: [
      {
        quote: "After shipping our cargo to the New Jersey address, the entire process ran invisibly for us. Amazon orders kept going out without interruption.",
        role: "Apparel Seller — Türkiye",
      },
      {
        quote: "Direct delivery to buyers lets us serve our US customers as if we had a local warehouse there.",
        role: "Home Goods Exporter — İzmir",
      },
      {
        quote: "Once we shared our operation profile, everything was planned quickly and our first shipment went out in no time.",
        role: "Gift Brand — İstanbul",
      },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Frequently asked questions",
    items: [
      {
        q: "Which products do you accept?",
        a: "We accept all general merchandise that does not require cold chain — apparel, gift items, shoes, home goods, toys and more. Food and cold chain products are outside our acceptance scope.",
      },
      {
        q: "How do my products get sold on Amazon?",
        a: "Once your products are received at our warehouse, we complete prep, labeling and packaging so they can be listed and sold on Amazon. The entire operation is run by ON-ALL.",
      },
      {
        q: "How do I use your warehouse address?",
        a: "After you send the quote form, we share your dedicated New Jersey warehouse address and receiving instructions. You simply route your cargo to that address.",
      },
      {
        q: "How is pricing determined?",
        a: "We prepare a custom quote based on your shipment volume and chosen service model. Fill in the calculator and we'll get back to you as soon as your request arrives.",
      },
    ],
  },
  footer: {
    tagline: "Your fulfillment and Amazon operations hub, at the heart of the US in New Jersey.",
    navTitle: "SITE",
    contactTitle: "CONTACT",
    rights: "All rights reserved.",
    excluded: "Food & cold chain products are not accepted.",
  },
  whatsappFloat: "Chat on WhatsApp",
};

const dictionaries = { tr, en };

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = {
    lang,
    setLang,
    t: dictionaries[lang],
    toggle: () => setLang((l) => (l === "tr" ? "en" : "tr")),
  };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
